var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wkb-sig-chain-matrix" }, [
    _vm.title
      ? _c("h4", { staticClass: "wkb-sig-chain-matrix-title" }, [
          _vm._v(_vm._s(_vm.title)),
        ])
      : _vm._e(),
    !_vm.hasData
      ? _c("p", { staticClass: "wkb-inspector-note" }, [
          _vm._v(" No rows were available for this matrix. "),
        ])
      : _c("div", { staticClass: "wkb-sig-chain-matrix-wrap" }, [
          _c("table", { staticClass: "wkb-sig-chain-matrix-table" }, [
            _c("thead", [
              _c(
                "tr",
                [
                  _c("th", { staticClass: "wkb-sig-chain-matrix-corner" }),
                  _vm._l(_vm.matrix.columns, function (column) {
                    return _c(
                      "th",
                      {
                        key: column.id,
                        staticClass: "wkb-sig-chain-matrix-col-head",
                      },
                      [_vm._v(" " + _vm._s(column.label) + " ")]
                    )
                  }),
                ],
                2
              ),
            ]),
            _c(
              "tbody",
              _vm._l(_vm.matrix.rows, function (row) {
                return _c(
                  "tr",
                  { key: row.id },
                  [
                    _c("th", { staticClass: "wkb-sig-chain-matrix-row-head" }, [
                      _vm._v(_vm._s(row.label)),
                    ]),
                    _vm._l(_vm.matrix.columns, function (column) {
                      return _c(
                        "td",
                        {
                          key: column.id,
                          staticClass: "wkb-sig-chain-matrix-cell-wrap",
                        },
                        [
                          _vm.cellLookup.get(`${row.id}::${column.id}`)
                            ? _c(
                                "button",
                                {
                                  staticClass: "wkb-sig-chain-matrix-cell",
                                  class: {
                                    "is-active":
                                      _vm.activeCellKey ===
                                      `${row.id}::${column.id}`,
                                  },
                                  attrs: {
                                    type: "button",
                                    title:
                                      _vm.cellLookup.get(
                                        `${row.id}::${column.id}`
                                      ).hover_text || "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$emit(
                                        "cell-click",
                                        _vm.cellLookup.get(
                                          `${row.id}::${column.id}`
                                        ),
                                        `${row.id}::${column.id}`
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatScore(
                                          _vm.title,
                                          _vm.cellLookup.get(
                                            `${row.id}::${column.id}`
                                          ).score
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _c(
                                "span",
                                { staticClass: "wkb-sig-chain-matrix-empty" },
                                [_vm._v("—")]
                              ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              }),
              0
            ),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }